<template>
  <div>
    <PageSwiper :height="680" location="HOME"/>

    <div class="about-us">
      <!-- <video :src="$utils.getFileHttpUrl(aboutUsInfo.video)" autoplay controls class="us-video"></video> -->
      <video id="myVideo" ref="videoPlayer" class="video-js vjs-paused vjs-big-play-centered" width="680" height="420" @contextmenu.prevent></video>
      <div class="about-right">
        <div class="title-row">
          <div class="title-text">关于我们</div>
          <div class="title-more" @click="$router.push({name: 'enterpriseIndex'})">
            <div>MORE</div>
            <img src="@/assets/arrow-right.png" />
          </div>
        </div>
        <div class="intro-text">
          <div v-html="aboutUsInfo.content"></div>
        </div>
        <div class="num-row">
          <div class="num-item">
            <div class="num-text">{{ aboutUsInfo.certs }}</div>
            <div class="num-tips">获取资质</div>
          </div>
          <div class="num-item">
            <div class="num-text">{{ aboutUsInfo.awards }}</div>
            <div class="num-tips">获得奖项</div>
          </div>
        </div>
      </div>
    </div>

    <div class="biz-range">
      <div class="biz-main">
        <div class="biz-left">
          <div class="biz-title">业务范畴</div>
          <div class="biz-link" @click="gotoBizPage('bizScope')">了解更多</div>
        </div>
        <div class="biz-right">
          <swiper class="biz-range-swiper" ref="bizRangeSwiper" :options="bizRangeSwiperOption">
            <swiper-slide v-for="(item, index) in bizRangeData" :key="index">
              <div class="biz-top">
                <img :src="$utils.getFileHttpUrl(item.img)" :title="item.name"/>
              </div>
              <div class="biz-name">{{ item.subTitle }}</div>
            </swiper-slide>
          </swiper>
          <img src="@/assets/swiper-prev.png" class="biz-swiper-button-prev" slot="button-prev" />
          <img src="@/assets/swiper-next.png" class="biz-swiper-button-next" slot="button-next" />
          <div class="biz-swiper-pagination" slot="pagination"></div>
        </div>
      </div>
    </div>

    <div class="case-box">
      <div class="case-title">
        <div>服务案例</div>
        <div class="title-more" @click="gotoBizPage('case')">
          <div>MORE</div>
          <img src="@/assets/arrow-right.png" />
        </div>
      </div>
      <swiper class="case-swiper" ref="caseSwiper" :options="caseSwiperOption">
        <swiper-slide v-for="(item, index) in caseData" :key="index">
          <img :src="$utils.getFileHttpUrl(item.img)" />
          <div class="case-project">
            <div class="project-name">{{ item.subTitle }}</div>
            <div class="project-line"></div>
          </div>
        </swiper-slide>
      </swiper>
<!--       
      <img src="@/assets/swiper-next.png" class="swiper-button-next" slot="button-next" />
      <img src="@/assets/swiper-prev.png" class="swiper-button-prev" slot="button-prev" /> -->
    </div>

    <div class="honor-box">
      <div class="honor-content">
        <div class="honor-title">
          <div>荣誉资质</div>
          <div class="title-more" @click="gotoBizPage('honor')">
            <div>MORE</div>
            <img src="@/assets/arrow-right-white.png" />
          </div>
        </div>

        <div class="honor-footer">
          <swiper class="honor-swiper" :options="honorSwiperOption">
            <swiper-slide v-for="(item, index) in honorData" :key="index">
              <img :src="$utils.getFileHttpUrl(item)" />
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
    </div>

    <div class="news-box">
      <div class="news-title">
        <div>新闻中心</div>
        <div class="title-more" @click="gotoBizPage('news')">
          <div>MORE</div>
          <img src="@/assets/arrow-right.png" />
        </div>
      </div>
      <div class="news-main">
        <div class="news-left">
          <div v-for="item in newsData" :key="item.id" class="news-item">
            <div class="news-title">{{ item.title }}</div>
            <div class="news-text" v-html="$utils.escape2Html(item.content)"></div>
            <div class="news-footer">
              <div class="news-time">{{ item.time }}</div>
              <div class="news-more" @click="gotoNewsPage(item.id)">MORE >></div>
            </div>
          </div>
        </div>
        <div class="news-right">
          <swiper class="news-swiper" :options="newsSwiperOption">
            <swiper-slide v-for="item in newsData" :key="item.id">
              <img :src="$utils.getFileHttpUrl(item.img)" />
            </swiper-slide>
          </swiper>
          <div class="news-swiper-pagination" slot="pagination"></div>
        </div>
      </div>
    </div>

    <div id="backTop">
      <img src="@/assets/back-top.png" class="arrow" />
      <div class="text">返回顶部</div>
    </div>
  </div>
</template>

<script>
import PageSwiper from '@/components/PageSwiper'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import videojs from 'video.js'
import 'video.js/dist/video-js.css'
export default {
  components: { PageSwiper, Swiper, SwiperSlide },
  data() {
    return {
      aboutUsInfo: {},
      bizRangeSwiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        slidesPerView: 'auto',
        spaceBetween: 30,
        navigation: {
          prevEl: '.biz-swiper-button-prev',
          nextEl: '.biz-swiper-button-next'
        },
        pagination: {
          el: '.biz-swiper-pagination',
          clickable: true
        },
        on: {
          click: () => {
            const swiper = this.$refs.bizRangeSwiper.$swiper
            const totalRealSlides = this.bizRangeData.length
            let realIndex = swiper.clickedIndex - swiper.loopedSlides
            if (realIndex < 0) {
              realIndex += totalRealSlides
            } else if (realIndex >= totalRealSlides) {
              realIndex -= totalRealSlides
            }
            console.log('点击的真实索引:', realIndex)
            this.$router.push({name: 'bizScope', query: {realIndex: realIndex}})
          }
        }
      },
      bizRangeData: [],
      caseSwiperOption: {
        speed: 3000,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        slidesPerView: 4,
        spaceBetween: 40,
        //navigation: {
         // prevEl: '.swiper-button-prev',
          //nextEl: '.swiper-button-next'
        //},
        breakpoints: {
          320: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 40
          }
        },
        on: {
          click: () => {
            const swiper = this.$refs.caseSwiper.$swiper
            const totalRealSlides = this.caseData.length
            let realIndex = swiper.clickedIndex - swiper.loopedSlides
            if (realIndex < 0) {
              realIndex += totalRealSlides
            } else if (realIndex >= totalRealSlides) {
              realIndex -= totalRealSlides
            }
            console.log('点击的真实索引:', realIndex)
            this.$router.push({name: 'case', query: {realIndex: realIndex}})
          }
        }
      },
      caseData: [],
      honorSwiperOption: {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        // navigation: {
        //   prevEl: '.swiper-button-prev',
        //   nextEl: '.swiper-button-next'
        // },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          progress: function (progress) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              var slideProgress = this.slides[i].progress
              var modify = 1
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
              }
              var translate = slideProgress * modify * 90 + 'px'
              var scale = 1 - Math.abs(slideProgress) / 5
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
              slide.transform('translateX(' + translate + ') scale(' + scale + ')')
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0)
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      },
      honorData: [],
      newsSwiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.news-swiper-pagination'
        }
      },
      newsData: [],
      player: ''
    }
  },
  created() {
    this.getAboutUs()
    this.getBizRange()
    this.getCaseData()
    this.getHonorData()
    this.getNewsData()
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToTop({ elem: 'backTop', showDistance: window.innerHeight })
    })
  },
  methods: {
    scrollToTop({ elem, speed = 5, top = 0, showDistance = 500, callback }) {
      // 获取返回顶部按钮
      let backToTopButton = document.getElementById(elem)
      // 当页面滚动时显示或隐藏返回顶部按钮
      window.onscroll = () => {
        // 获取当前滚动的位置
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
        // 判断是否超过设置的显示距离，超过就显示，否则就隐藏
        if (currentScroll > showDistance) {
          backToTopButton.style.display = 'block'
        } else {
          backToTopButton.style.display = 'none'
        }
      }
      // 平滑滚动到顶部
      backToTopButton.addEventListener('click', () => {
        // 获取当前滚动的位置
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
        // 如果当前不在顶部，则开始滚动动画
        if (currentScroll > top) {
          window.requestAnimationFrame(smoothScroll) // 运行动画
        } else {
          // 到达指定位置，执行回调函数
          callback && callback()
        }
      })
      // 滚动函数
      function smoothScroll() {
        // 获取当前滚动的位置
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
        // 如果当前不在顶部，则开始滚动动画
        if (currentScroll > top) {
          window.requestAnimationFrame(smoothScroll)
          console.log(currentScroll)
          window.scrollTo(0, currentScroll - currentScroll / speed) // 控制滚动速度
        }
      }
    },
    gotoHref(href) {
      if (this.$utils.isUrl(href)) {
        window.open(href)
      }
    },
    getAboutUs() {
      this.$http.getAction('/portal/api/v1/index/about/us').then((res) => {
        if (res.success) {
          this.aboutUsInfo = res.data
          this.player = videojs(this.$refs.videoPlayer, {
            autoplay: 'any',
            // fluid: true,
            preload: 'auto',
            language: 'zh-CN',
            controls: true,
            controlBar: {
              playToggle: true,
              progressControl: false,
              volumePanel: true,
              fullscreenToggle: true,
              remainingTimeDisplay: false
            },
          }, () => {
            const src = this.$utils.getFileHttpUrl(res.data.video)
            this.player.src(src)
          });
          this.aboutUsInfo.content = this.$utils.escape2Html(res.data.content)
        }
      })
    },
    gotoBizPage(name) {
      this.$router.push({name: name})
    },
    getBizRange() {
      this.$http.getAction('/portal/api/v1/index/business/scope').then((res) => {
        if (res.success) {
          this.bizRangeData = res.data
        }
      })
    },
    getCaseData() {
      this.$http.getAction('/portal/api/v1/index/service').then((res) => {
        if (res.success) {
          this.caseData = res.data
        }
      })
    },
    getHonorData() {
      this.$http.getAction('/portal/api/v1/index/honor').then((res) => {
        if (res.success) {
          this.honorData = res.data
        }
      })
    },
    getNewsData() {
      this.$http.getAction('/portal/api/v1/index/news').then((res) => {
        if (res.success) {
          this.newsData = res.data
        }
      })
    },
    gotoNewsPage(id) {
      this.$router.push({name: 'newsDetail', params: {id: id}})
    }
  },
  beforeDestroy() {
    if (this.player) {
        this.player.dispose()
    }
  }
}
</script>

<style lang="scss" scoped>

.about-us {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 120px auto 60px;
  .us-video {
    width: 680px;
    height: 420px;
  }
  .about-right {
    width: 470px;
    .title-row {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-text {
        font-weight: 800;
        font-size: 40px;
        color: #000000;
      }
      .title-more {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #777777;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
    .intro-text {
      margin-top: 24px;
      // font-weight: 500;
      // font-size: 14px;
      // color: #666666;
      // line-height: 22px;
      max-height: 308px;
      overflow: hidden;
    }
    .num-row {
      margin-top: 20px;
      display: flex;
      .num-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 100px;
        .num-text {
          height: 50px;
          font-weight: bold;
          font-size: 40px;
          color: #0282de;
          line-height: 50px;
          letter-spacing: 2px;
          position: relative;
          &::after {
            position: absolute;
            right: -25px;
            top: -15px;
            display: block;
            content: '+';
            font-size: 30px;
            color: #0282de;
            letter-spacing: 1px;
          }
        }
        .num-tips {
          height: 30px;
          font-weight: bold;
          font-size: 18px;
          color: #3f3f3f;
          line-height: 30px;
        }
      }
    }
  }
}

.biz-range {
  margin: 60px 0;
  height: 570px;
  padding-top: 150px;
  background-image: url(../assets/biz-bg.jpg);
  background-size: cover;
  .biz-main {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 570px;
    .biz-left {
      padding-right: 80px;
      flex-shrink: 0;
      .biz-title {
        height: 40px;
        font-weight: 800;
        font-size: 40px;
        color: #ffffff;
        line-height: 47px;
      }
      .biz-link {
        margin-top: 47px;
        border-radius: 10px;
        border: 1px solid #ffffff;
        padding: 12px 40px;
        cursor: pointer;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .biz-right {
      width: 860px;
      position: relative;
      .biz-range-swiper {
        width: 100%;
        .swiper-slide {
          width: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .biz-top {
            height: 400px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            img {
              width: 266px;
              height: 400px;
              object-fit: cover;
              cursor: pointer;
            }
          }
          .biz-name {
            margin-top: 14px;
            width: 240px;
            font-weight: 600;
            font-size: 26px;
            color: #ffffff;
            text-align: center;
            line-height: 35px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 20px;
          }
        }
        // .swiper-slide-active {
        //   .biz-top {
        //     img {
        //       width: 320px;
        //       height: 400px;
        //       object-fit: cover;
        //     }
        //   }
        //   .biz-name {
        //     width: 320px;
        //   }
        // }
      }
      .biz-swiper-pagination {
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
      }
      .biz-swiper-button-prev {
        position: absolute;
        width: 60px;
        height: 60px;
        left: -90px;
        top: 50%;
        cursor: pointer;
      }
      .biz-swiper-button-next {
        position: absolute;
        width: 60px;
        height: 60px;
        right: -90px;
        top: 50%;
        cursor: pointer;
      }
    }
  }
}

.case-box {
  padding: 60px 0;
  position: relative;
  .case-title {
    margin: 0 auto 100px;
    width: 1200px;
    text-align: center;
    font-weight: 800;
    font-size: 40px;
    color: #000000;
    position: relative;
    .title-more {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: #777777;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .case-swiper {
    width: 100%;
    height: 375px;
    .swiper-slide {
      cursor: pointer;
      img {
        width: 100%;
        height: 300px;
        object-fit: cover;
      }
      .case-project {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;
        height: 55px;

        .project-name {
          font-weight: 800;
          font-size: 20px;
          color: #000000;
          text-align: center;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 20px;
        }

        .project-line {
          width: 70px;
          height: 10px;
          background: #0282de;
        }
      }
    }
  }
  .swiper-button-prev {
    left: 10px;
    right: auto;
  }
  .swiper-button-next {
    right: 10px;
    left: auto;
  }
}

.honor-box {
  padding: 60px 0;
  .honor-content {
    height: 560px;
    padding-top: 120px;
    background-image: url(../assets/honor-bg.jpg);
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .honor-title {
      margin: 0 auto 0px;
      width: 1200px;
      text-align: center;
      font-weight: 800;
      font-size: 40px;
      color: #fff;
      position: relative;
      .title-more {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
    .honor-footer {
      padding: 60px 270px 0;
      height: 440px;
      position: relative;
      .honor-swiper {
        width: 100%;
        height: 440px;
        .swiper-slide {
          width: 420px;
          height: 300px;
          img {
            width: 100%;
            height: 300px;
            object-fit: cover;
          }
        }
      }
      .swiper-button-prev {
        left: 120px;
        right: auto;
      }
      .swiper-button-next {
        right: 120px;
        left: auto;
      }
      .swiper-pagination {
        bottom: 60px;
      }
    }
  }
}

.news-box {
  padding: 60px 0;
  .news-title {
    margin: 0 auto 60px;
    width: 1200px;
    text-align: center;
    font-weight: 800;
    font-size: 40px;
    color: #000000;
    position: relative;
    .title-more {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: #777777;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .news-main {
    display: flex;
    justify-content: space-between;
    min-width: 1200px;
    width: 1200px;
    margin: 0 auto;
    .news-left {
      .news-item {
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
        margin-bottom: 24px;
        width: 460px;
        padding: 19px 16px 15px;
        .news-title {
          width: 460px;
          font-weight: 800;
          font-size: 18px;
          color: #1c1c20;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 18px;
        }
        .news-text {
          width: 460px;
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          line-height: 22px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          overflow: hidden;
          min-height: 44px;
        }
        .news-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 18px;
          .news-time {
            font-weight: 500;
            font-size: 12px;
            color: #999999;
          }
          .news-more {
            font-weight: 500;
            font-size: 12px;
            color: #666666;
            cursor: pointer;
          }
        }

        &:nth-of-type(3) {
          margin-bottom: 0;
        }
      }
    }
    .news-right {
      width: 680px;
      position: relative;
      .news-swiper {
        width: 100%;
        height: 510px;
        .swiper-slide {
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .news-swiper-pagination {
        position: absolute;
        right: 20px;
        bottom: 20px;
        z-index: 100;
        ::v-deep(.swiper-pagination-bullet) {
          width: 8px;
          height: 8px;
        }
      }
    }
  }
}

#backTop {
  display: none;
  position: fixed;
  z-index: 1000;
  bottom: 300px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  text-align: center;
  cursor: pointer;
  .arrow {
    padding-top: 18px;
    width: 20px;
    height: 20px;
  }
  .text {
    // padding-top: 10px;
    font-weight: 500;
    font-size: 12px;
    color: #000000;
  }
}
</style>
<style>
.swiper-button-prev {
  width: 60px;
  height: 60px;
  right: 360px;
}
.swiper-button-prev.swiper-button-disabled {
  /* display: none; */
}
.swiper-button-next {
  width: 60px;
  height: 60px;
  right: 360px;
}
.swiper-button-next.swiper-button-disabled {
  /* display: none; */
}

.swiper-pagination {
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
}
.swiper-pagination-bullet {
  width: 32px;
  height: 8px;
  background: #323232;
  border-radius: 50px 50px 50px 50px;
  margin: 0 4px;
  opacity: 0.5;
}
.swiper-pagination-bullet-active {
  background: #ffffff;
  opacity: 1;
}

.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
    display: block;
}
</style>
